import { ParserFunction } from '../type';

export const socialDescriptionParser: ParserFunction = ({ name }) => `Browse ${name}'s reviews, starting rates, specialties, offered services and more.`;
